import React from 'react';
import { SLDSButtonGroup } from '@salesforce/design-system-react';

const ButtonGroup = props => /*#__PURE__*/React.createElement(SLDSButtonGroup, props);
ButtonGroup.displayName = "ButtonGroup";
ButtonGroup.propTypes = SLDSButtonGroup.propTypes;
ButtonGroup.defaultProps = SLDSButtonGroup.defaultProps;
var ButtonGroup$1 = ButtonGroup;

export { ButtonGroup$1 as default };
